import { render } from "./ViewPayrollPayslips.vue?vue&type=template&id=e9243ad4&scoped=true"
import script from "./ViewPayrollPayslips.vue?vue&type=script&lang=js"
export * from "./ViewPayrollPayslips.vue?vue&type=script&lang=js"

import "./ViewPayrollPayslips.vue?vue&type=style&index=0&id=e9243ad4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9243ad4"]])

export default __exports__